.inputContainer {
  input[type=number]::-webkit-inner-spin-button,
  input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  
  width: 100%;
  box-sizing: border-box;

  .inlineLabel {
    max-width: 75%;
  }

  .required {
    background-color: #fadcdc;
    border: solid 1px #d9384b;
  }

  .errorText {
    font-size: 14px;
    font-weight: 500;
    color: #d9384b;
    padding-left: 2px;
  }

  .labelComment {
    margin-left: 6px !important;
    color: #667885 !important;
  }
}
